import { useEffect, useState } from 'react';
import Lenis from 'lenis';
import { MotionConfig, useReducedMotion } from 'framer-motion';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { MenuSection } from './components/MenuSection';
import { Atmosphere } from './components/Atmosphere';
import { GalleryReviews } from './components/GalleryReviews';
import { VisitFooter } from './components/VisitFooter';
import { Reservation } from './components/Reservation';
import { LanguageContext, getOpenStatus } from './lib/site';
import 'lenis/dist/lenis.css';
import './App.css';

function App() {
  const [lang, setLang] = useState(() => { try { return localStorage.getItem('oranjina-language') === 'en' ? 'en' : 'ro'; } catch { return 'ro'; } });
  const [reservationOpen, setReservationOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(getOpenStatus);
  const reduced = useReducedMotion();
  const t = (ro, en) => lang === 'ro' ? ro : en;
  useEffect(() => {
    document.documentElement.lang = lang;
    try { localStorage.setItem('oranjina-language', lang); } catch { /* Language remains usable without storage. */ }
    document.title = lang === 'ro' ? 'OranjinaBiscotina — Gust bun. Chef de stat. | Terasă Mogoșoaia' : 'OranjinaBiscotina — Good food. Better moments. | Café in Mogoșoaia';
    document.querySelector('meta[name="description"]')?.setAttribute('content', lang === 'ro' ? 'Mâncare gătită, clătite, frappé și o terasă primitoare în Mogoșoaia. OranjinaBiscotina, Str. Constantin Brâncoveanu 8A. Zilnic 09:30–21:30. 0784 173 284.' : 'Freshly cooked food, crêpes, frappés and a welcoming terrace in Mogoșoaia. OranjinaBiscotina, 8A Constantin Brâncoveanu Street. Daily 09:30–21:30. +40 784 173 284.');
  }, [lang]);
  useEffect(() => {
    if (reduced) return;
    const lenis = new Lenis({ autoRaf: true, duration: 1.15, anchors: { offset: -95 }, smoothWheel: true });
    return () => lenis.destroy();
  }, [reduced]);
  useEffect(() => { const timer = setInterval(() => setIsOpen(getOpenStatus()), 30000); return () => clearInterval(timer); }, []);
  const onReserve = () => setReservationOpen(true);
  return <LanguageContext.Provider value={{ lang, setLang, t }}><MotionConfig reducedMotion="user"><a href="#main-content" className="skip-link" data-testid="skip-to-content">{t('Sari la conținut', 'Skip to content')}</a><Header onReserve={onReserve}/><main id="main-content"><Hero isOpen={isOpen}/><Story/><MenuSection/><Atmosphere/><GalleryReviews/><VisitFooter isOpen={isOpen}/></main><Reservation open={reservationOpen} onOpenChange={setReservationOpen}/><Toaster position="bottom-center" theme="light" richColors/></MotionConfig></LanguageContext.Provider>;
}
export default App;